export default __webpack_public_path__ + "static/media/no-pr-img.b41a7609.jpg";